import React from "react";
import FeedbackChecklist from "./FeedbackChecklist";

// Separate report of phase rejections for A&S TLs (BRD 6499).
const PhaseRejections = (props) => <FeedbackChecklist {...props} phaseRejections />;

export default PhaseRejections;
